<template>
    <Pie :data="chartData" :options="chartOptions" />
</template>

<script>
import { Pie } from "vue-chart-3";

export default {
    extends: Pie,
    props: {
        datasets: Array,
        labels: Array,
        options: Object,
    },
    data() {
        return {
            defaultDataset: {
                data: [],
                borderColor: "rgb(255,190,70, .4)",
                backgroundColor: "rgb(255,190,70,.2)",
                borderWidth: 2,
            },
            optionsDefaults: {
                maintainAspectRatio: false,
                responsive: true,
            },
        };
    },
    created() {
        this.render = _.debounce(this.render, 500, {
            leading: false,
            trailing: true,
        });
        this.render();
        this.$root.$on("dashboard:resize" + this.$vnode.key, this.render);
    },
    watch: {
        chartData: {
            handler: function() {
                this.render();
            },
            deep: true,
        },
    },
    methods: {
        render() {
            // this.renderChart(this.chartData, this.chartOptions);
        },
    },
    computed: {
        chartData() {
            var data = {};
            var length = 0;
            data.labels = this.labels || [];
            data.datasets = [];

            _.each(this.datasets, (dataset) => {
                data.datasets.push(
                    _.merge(
                        _.cloneDeep(this.defaultDataset),
                        _.cloneDeep(dataset)
                    )
                );
            });

            return data;
        },
        chartOptions() {
            return Object.assign(this.optionsDefaults, this.options);
        },
    },
};
</script>
